import { SOCKET_EVENTS } from "@markedesk/core-contracts";

/**
 * Assina as mudanças de conexão para a tela "Gerenciar conexões".
 *
 * O socket do app é o namespace da empresa LOGADA — não existe assinar as
 * outras empresas por aqui. O que chega de conexão alheia é o que o backend
 * decide reemitir para o super-admin (`updateAdmin`, `emitAdminDeletion` e
 * os callbacks de sessão). Um handler por EVENTO; a lista de empresas serve
 * só para o chamador re-assinar quando ela muda (#4418 — antes registrava o
 * mesmo handler N vezes e processava cada evento N vezes).
 *
 * Dois eventos, dois formatos:
 *  - WHATSAPP.CHANGED: `{ action: "update", whatsapp }` ou `{ action: "delete", whatsappId }`
 *  - WHATSAPP.SESSION: `{ action: "update", session }` (status/qrcode ao vivo)
 *
 * @returns função de limpeza para o `useEffect`.
 */
export function subscribeConnectionsChanged(socket, onUpdate, _companyIds, onDelete) {
  if (!socket) return () => {};

  const onChanged = (data) => {
    if (data?.action === "update" && data.whatsapp) onUpdate(data.whatsapp);
    if (data?.action === "delete" && data.whatsappId && onDelete) onDelete(data.whatsappId);
  };
  const onSession = (data) => {
    if (data?.action === "update" && data.session) onUpdate(data.session);
  };
  socket.on(SOCKET_EVENTS.WHATSAPP.CHANGED, onChanged);
  socket.on(SOCKET_EVENTS.WHATSAPP.SESSION, onSession);
  return () => {
    socket.off(SOCKET_EVENTS.WHATSAPP.CHANGED, onChanged);
    socket.off(SOCKET_EVENTS.WHATSAPP.SESSION, onSession);
  };
}
